import { createContext, useCallback, useContext, useMemo } from 'react';

import PropTypes from 'prop-types';

const CarouselContext = createContext();

const useCarouselContext = () => {
  const context = useContext(CarouselContext);

  if (!context) {
    throw new Error('useCarouselContext must be used within the CarouselContextProvider');
  }

  return context;
};

const CarouselContextProvider = ({ children, emblaApi }) => {
  const stopAutoplay = useCallback(() => {
    emblaApi.plugins().autoplay.stop();
  }, [emblaApi]);

  const contextValue = useMemo(
    () => ({
      stopAutoplay
    }),
    [stopAutoplay]
  );

  return <CarouselContext.Provider value={contextValue}>{children}</CarouselContext.Provider>;
};

CarouselContextProvider.propTypes = {
  emblaApi: PropTypes.shape({
    plugins: PropTypes.func
  })
};

export { CarouselContextProvider, useCarouselContext };
